<div class="widget" id="vtr-widget">

  <div *ngIf="!this.mockVideos" id="vtr-controls">
    <p class="usercount">
      <mat-icon (dblclick)="toggleMockVideo()">accessibility</mat-icon>
      <span>{{usercount}}</span>
    </p>

    <mat-slide-toggle (change)="toggleVTRConnectionState()" [checked]="connected">
      {{'widgets.vtr.start' | translate}}
    </mat-slide-toggle>
    <mat-slide-toggle (change)="toggleCopilotState()" [checked]="copilotState">
      Copilot
    </mat-slide-toggle>

    <span *ngIf="!this.mockVideos">
      <button class="mute-button" *ngIf="remoteVideoElements.size > 0" mat-button (click)="toggleAudio()">
        <mat-icon *ngIf="isVolumeOff">volume_off</mat-icon>
        <mat-icon *ngIf="!isVolumeOff">volume_up</mat-icon>
      </button>
    </span>
  </div>

  <!-- This only serves to turn off-mock mode -->
  <mat-icon *ngIf="this.mockVideos" (dblclick)="toggleMockVideo()">accessibility</mat-icon>

  <div id="vtr-videocontainer">
  </div>
</div>
